import { Component, computed, inject, Signal } from '@angular/core';
import { ThemingService } from '../../core/theming/theming.service';
import { toImageUri } from '../atom/img/img.utils';
import { ImgComponent } from '../atom/img/img.component';
import { NoValue } from '@tribeauto/ngx-mobilite-material';
import { toSignal } from '@angular/core/rxjs-interop';
import { Theming } from '../../core/theming/theming.model';

@Component({
  selector: 'fol-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [ImgComponent]
})
export class HeaderComponent {
  private readonly themingService: ThemingService = inject(ThemingService);

  private theming: Signal<Theming | NoValue> = toSignal(this.themingService.getCurrentTheming());

  protected readonly src: Signal<string | null> = computed(() => {
    const theming = this.theming();
    return theming?.logoBytes ? toImageUri(theming.logoFileName, theming.logoBytes) : null;
  });
  protected readonly brandImageName = computed(() => [this.theming()?.brand, 'logo'].join(' '));
}
